import React from "react"
import Responsive from "react-responsive"

import Banner from "./Banner"
import { ReactComponent as WorldMapMobile } from "./dotted-world-map-mobile.svg"

const Desktop = props => <Responsive {...props} minWidth={700} />
const Mobile = props => <Responsive {...props} minWidth={0} maxWidth={699} />

const Section2 = () => {
  return (
    <section className="section2">
      <h1 className="section2-banner">
        DigiWall supports <span className="section2-figures">10+</span> payment
        providers across <span className="section2-figures">40+</span> countries
      </h1>
      <Banner />
      <Desktop>
        <img
          className="section2-worldmap"
          src="/images/Section2/dotted-world-map-desktop.svg"
          alt="World Map"
        />
      </Desktop>
      <Mobile>
        <WorldMapMobile className="section2-worldmap" />
      </Mobile>
    </section>
  )
}

export default Section2
